'use strict';

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
import { Card, Form, Button } from 'react-bootstrap';
import styled from '@emotion/styled';

const ServerRequest = require('../../actions/request');
const KeyboardUtil = require('../../util/keyboard');
import ErrorBox from '../common/ErrorBox';

let ActivityDiv = styled.div`
    padding: 1rem;
    label {
        display: block;
        span {
            margin-left: 1rem;
        }
        margin-bottom: 0.5rem;
    }
    margin: 1rem;
`;

const propTypes = {};
const defaultProps = {};

class AdminFindActivity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activity_id: "",
        };

        this.unsubscribes = [
            // RegisterStore.listen(this.onRegisterStoreStateChange.bind(this))
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    
    onActivityIdChange=(e)=>{
        this.setState({activity_id: e.target.value});
    }
    
    handleKeyDown(e){
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            this.doFindActivity();
        }
    }
    
    doFindActivity=()=>{
        let hash = this.state.activity_id;
        this.setState({scanning:true,activity:null,error:null},()=>{
            ServerRequest.makeRequest(`/authoring/activity_lookup/${hash}`, 'GET')
            .then((activity)=>{
                // console.log("activity:",activity); // FIXME
                this.setState({scanning:false, activity});
            })
            .catch((error)=>{
                this.setState({scanning:false, error});
            })
        });
    }
    
    render() {
        let url,channelName;
        const act = this.state.activity;
        if (act) {
            url =`/project/${act.owner_id}/${act.project_id}/activity/${act.id}`;
            let channelUser = act.channelUser;
            if (channelUser) {
                channelName = channelUser.display_name;
            }
        }

        return (
            <Card body bg="light">
                <ErrorBox error={this.state.error} />
                <Form>
                    <Form.Group controlId="admin-find-activity">
                        <Form.Label>activity id (hash):</Form.Label>
                        <Form.Control
                            type="text"
                            aria-label="activity id"
                            value={this.state.activity_id}
                            onChange={this.onActivityIdChange}
                            onKeyDown={this.handleKeyDown}
                            disabled={this.state.scanning}
                        />
                    </Form.Group>
                    <Button disabled={this.state.scanning} onClick={this.doFindActivity}>
                        find
                    </Button>
                    {act ? 
                    <ActivityDiv className="activity-section">
                        <label>
                            {'Activity:'}
                            <span>{act.title}</span>
                        </label>
                        <label>
                            {'Project:'}
                            <span>{act.project_name}</span>
                        </label>
                        {channelName ? 
                        <label>
                            {'Channel:'}
                            <span>{channelName}</span>
                        </label>
                        : null }
                        <label>
                            {'Link:'}
                            <a className="trad-link" 
                                // onClick={()=>{this.props.history.push(url)}}
                                href={url}>
                                {act.title}
                            </a>
                        </label>
                    </ActivityDiv>
                    : null }
                </Form>
            </Card>
        );
    }
}

AdminFindActivity.propTypes = propTypes;
AdminFindActivity.defaultProps = defaultProps;

export default AdminFindActivity;
